import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "time-selector-container slide" }
const _hoisted_2 = {
  key: 0,
  class: "slide-header"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "slider-title" }, "Choose a Time", -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "slide-content" }
const _hoisted_6 = {
  key: 0,
  class: "selected-date"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Selected Date & Time", -1 /* HOISTED */)
const _hoisted_8 = { class: "date" }
const _hoisted_9 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isAvailableTimes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode($setup["timeScroller"], {
        class: "scroller",
        "onUpdate:selectedChunk": $setup.setSelectedTime,
        isPreviousDay: $setup.isPreviousDay,
        isAvailableTimes: $setup.isAvailableTimes,
        "onUpdate:isAvailableTimes": $setup.updateIsAvailableTimes
      }, null, 8 /* PROPS */, ["isPreviousDay", "isAvailableTimes"]),
      ($setup.isAvailableTimes)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString($setup.selectedTime ? $setup.selectedTimeString : "Choose a time"), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        class: "borderless back",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('previous')))
      }, "Back"),
      ($setup.isAvailableTimes)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "borderless",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('progress')))
          }, "Next"))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}